// The platform's public pages: one addition to Frappe's own sign-in page.
//
// The sign-in card has no way to a new account (Frappe's own signup is
// off, on purpose: accounts are made by the registration form, which
// builds a site). So the card gets one line under it: "New here? Create
// your account", pointing at /signup. Nothing else on the page changes.
(function () {
	function addRegisterLink() {
		if (window.location.pathname !== "/login") return;
		var card = document.querySelector(".page-card .page-card-body, .page-card");
		if (!card || document.querySelector(".ksa-login-register")) return;
		var lang = (document.documentElement.getAttribute("lang") || "en").slice(0, 2) === "ar" ? "ar" : "en";
		var words = {
			en: ["New here?", "Create your account"],
			ar: ["جديد هنا؟", "أنشئ حسابك"],
		}[lang];
		var p = document.createElement("p");
		p.className = "ksa-login-register";
		p.appendChild(document.createTextNode(words[0] + " "));
		var a = document.createElement("a");
		a.href = "/signup";
		a.textContent = words[1];
		p.appendChild(a);
		card.appendChild(p);
	}
	if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", addRegisterLink);
	else addRegisterLink();
})();
